import { Injectable } from '@angular/core';
import { CustomOccProduct, CustomProduct } from '@product/const';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class ProductUriNameNormalizer implements Converter<Partial<CustomOccProduct>, Partial<CustomProduct>> {
  convert(source: Partial<CustomOccProduct>, target?: CustomProduct): Partial<CustomProduct> {
    if (target === undefined) {
      target = { ...(source as any) };
    }

    if (source.slug && source.code) {
      target.uriName = this.normalize(source);
    }

    return target;
  }

  private normalize(product: Partial<CustomOccProduct>): string {
    return [product.slug, product.code].join('-');
  }
}
